import angular from 'angular';

class legalEntityReadableCtrl {
    /*@ngInject*/
    constructor($translate, PrincipalSvc, logger, Upload, CONF, DEMATMODE) {
        this.$translate = $translate;
        this.PrincipalSvc = PrincipalSvc;
        this.Upload = Upload;
        this.CONF = CONF;
        this.logger = logger;
        this.DEMATMODE = DEMATMODE;
    }

    $onInit() {
        this.includes = {
            errorMessages: require('../../layouts/error-messages.html')
        };
        this.principal = angular.copy(this.resolve.principal);
        this.legalEntity = angular.copy(this.resolve.legalEntity);
        this.filtredAttributes = angular.copy(this.resolve.filtredAttributes);
        this.isDOCL = this.principal.detail.profilBuyer;
        this.isDOFO = this.principal.detail.profilSeller;
        this.canSubmit = true;
        this.options = Object.entries(this.DEMATMODE).map(([key, value]) => ({
            key,
            value
        }));
        this.uploadRequest = {};
        this.uploadRequest.id = this.legalEntity.id;
        this.uploadRequest.doId = this.principal.detail.eid;
        this.uploadRequest.filters = [{}, {}];
        this.uploadRequest.country = this.legalEntity.country.code;
        this.fillIdentifiers();
        // DO Four
        if (this.isDOCL) {
            this.uploadRequest.fluxType ="E"
        }
        //DO Client
        if (this.isDOFO && !this.isDOCL) {
            this.uploadRequest.fluxType ="S"
        }
    }

    getFilteredAttributes(index) {
        if (this.uploadRequest.filters[index].semanticPath) {
            return this.filtredAttributes.filter(attr => attr.path !== this.uploadRequest.filters[index].semanticPath);
        }
        return this.filtredAttributes;
    }

    handleSemanticPathChange(index) {
        if (!this.uploadRequest.filters[index].semanticPath) {
            this.uploadRequest.filters[index].value = null;
        }
    }


    fillIdentifiers() {
        this.uploadRequest.legalIdentifier = this.legalEntity.idFiscal || "";
        this.uploadRequest.taxIdentifier = this.legalEntity.idNational || "";
    }

    onFluxTypeChange(fluxType) {
        if (fluxType === 'entrant') {
            this.uploadRequest.fluxType ="E"
        } else {
            this.uploadRequest.fluxType ="S"
        }
    }

    checkFileSize() {
        const fileSize = this.uploadRequest.resource.size;
        const maxSizeInBytes = 200 * 1024 * 1024; // 200MB in bytes
        if (fileSize > maxSizeInBytes) {
            this.modalInstance.close();
            this.logger.error("Le fichier importé dépasse la taille maximale autorisée de 200MB");
            return false;
        }
        return true;
    }

    send() {
        if (this.form.$valid) {
            if (!this.checkFileSize()) {
                return;
            }
            this.canSubmit = false;
            this.uploadRequest.filters = this.uploadRequest.filters.map(filter =>
                filter && Object.keys(filter).length > 0 && filter.value != null && filter.semanticPath != null ? filter : {
                    semanticPath: "",
                    value: ""
                }
            );
            this.PrincipalSvc.uploadAndDeployClientResource(this.uploadRequest).then(
                result => {
                    if (result.status && result.status.statusType === "OK") {
                        this.logger.success("Le lisible a été importé avec succès", result);
                        this.modalInstance.close(result);
                    }
                },
                error => {
                    if ((error.status === 400 && error.data && error.data.code === 'INVALID_LEGIBLE_TEMPLATE') || error.status === 406) {
                        this.logger.error("Le fichier zip n'est pas au format attendu");
                    } else {
                        this.logger.error('error.generic', error);
                    }
                    this.canSubmit = true;
                }
            );
        }
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}

angular.module('app.principal').component('legalEntityReadableImport', {
    templateUrl: require('./modal-legal-entity-readable-import.html'),
    controller: legalEntityReadableCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
    },
});
